import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { Divider, Grid, Typography, TextField, FormControlLabel, Switch } from '@mui/material';
import { Button } from '@material-ui/core';
import { useEffect, useState, useRef } from 'react';
import { i18n } from '../../../translate/i18n';
import { makeStyles } from '@material-ui/core';
import { toast } from 'react-toastify';
import toastError from '../../../errors/toastError';
import api from '../../../services/api';
import SingleSelect from '../../InputStyled/singleSelect';
import * as Yup from "yup";
import FormatDate from '../../../helpers/FormatDate';

const Transition = React.forwardRef(function Transition(
    props,
    ref
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => ({
    button: {
        padding: "7px",
        float: "right",
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        "&:hover": {
            backgroundColor: theme.palette.primary.main,
        },
        "& svg": {
            color: theme.palette.primary.contrastText,
            marginRight: '5px'
        },
    },
}));

const getEndDate = (dt) => {
    const startDate = new Date(dt);
    const endDate = new Date(startDate);
    endDate.setMonth(endDate.getMonth() - 1);

    // Garantir que o dia não ultrapasse o último dia do mês anterior
    if (endDate.getDate() !== startDate.getDate()) {
        endDate.setDate(0); // Define para o último dia do mês anterior
    }

    return endDate.toISOString().split("T")[0];
}

const ImportWhatsappMessageStoreModal = ({ open, onClose, id, connectionId }) => {

    const classes = useStyles();
    const fullWidth = true;
    const maxWidth = 'md';
    const [loading, setLoading] = useState(false);
    const today = new Date().toISOString().split("T")[0];
    const [queues, setQueues] = useState([]);
    const initialState = {
        id: "",
        connectionId: "",
        queueId: "",
        startDate: today,
        endDate: getEndDate(today),
        limitByDate: false,
        allowGroups: true,
    };
    const [register, setRegister] = useState(initialState);
    const startRef = useRef(null);
    const endRef = useRef(null);

    useEffect(() => {
        if (open != true) return;

        setRegister((prevState) => ({
            ...prevState,
            connectionId
        }));

        (async () => {
            try {
                const { data: qs } = await api.get(`/queueListWithConnections/${connectionId}`);
                if (Array.isArray(qs)) setQueues(qs);
            } catch (err) {
                console.error({ err });
                toastError(err);
            }
            if (!id || id == '' || id == 'undefined') return;
            try {
                const { data } = await api.get(`/whatsapp/importMessageHistory/show/${id}`);
                if (data) setRegister({
                    ...data,
                    startDate: FormatDate(data.startDate, false, 2),
                    endDate: FormatDate(data.endDate, false, 2),
                });
            } catch (err) {
                console.error(err);
                toastError(err);
            } finally {
                setLoading(false);
            }
        })();

    }, [open]);

    const RegisterSchema = Yup.object().shape({
        queueId: Yup.string()
            .required(`${i18n.t("connections.whatsapp.importMessages.queue")} ${i18n.t("connections.whatsapp.importMessages.required")}`),
        startDate: Yup.string()
            .required(`${i18n.t("connections.whatsapp.importMessages.startDate")} ${i18n.t("connections.whatsapp.importMessages.required")}`),
        endDate: Yup.string()
            .required(`${i18n.t("connections.whatsapp.importMessages.endDate")} ${i18n.t("connections.whatsapp.importMessages.required")}`),
    });

    // reordenar para seguir sequencia correta
    if (RegisterSchema['_nodes']) RegisterSchema['_nodes'] = RegisterSchema['_nodes'].reverse();

    const handleClose = (event, reason) => {

        if (reason == 'backdropClick') {
            event.preventDefault();
            return;
        }

        setRegister(initialState);
        onClose();
    }

    const handleSave = async () => {
        let validated = false;

        try {
            setLoading(true);
            await RegisterSchema.validate(register);
            validated = true;

            // cadastrar
			await api.post('/whatsapp/importMessageHistory/store', {
                ...register,
                startDate: `${register.startDate} 23:59:59`,
                endDate: `${register.endDate} 00:00:00`,
            });

            setTimeout(() => {
                handleClose();
                setLoading(false);
                toast.success(i18n.t("connections.whatsapp.importMessages.savedSuccesfully"));
            }, 500);

        } catch(err) {
            if (validated == false) toast.error(err?.message ? i18n.t(err.message) : 'INTERNAL_ERROR');
			else toast.error(err?.response?.data?.message ? i18n.t(err.response.data.message) : 'INTERNAL_ERROR');
            setLoading(false);
        }
    }

    return (
        <Dialog
            open={open == true ? true : false}
            TransitionComponent={Transition}
            keepMounted
            onClose={(event, reason) => handleClose(event, reason)}
            aria-describedby="alert-dialog-slide-template"
            disableEscapeKeyDown={true}
            fullWidth={fullWidth}
            maxWidth={maxWidth}
        >
            <DialogTitle>
                {!id ? i18n.t("connections.whatsapp.importMessages.storeTitle") : i18n.t("connections.whatsapp.importMessages.editTitle")}
                <Divider sx={{ marginTop: "10px" }} />
            </DialogTitle>
            <DialogContent>
                <Grid container spacing={2} mb={2}>
                    <Grid item xs={12}>
                        <SingleSelect
                            title={
                                <Typography
                                    component="label"
                                    sx={{ fontSize: '1.1rem', marginBottom: '10px' }}
                                >
                                    {i18n.t("connections.whatsapp.importMessages.queue")} <Typography color="error" component="span">*</Typography>
                                </Typography>
                            }
                            displayText="Selecionar Fila"
                            options={queues.map((q) => ({ key: q.id, value: q.name }))}
                            onSelected={(opt) => {
                                setRegister((prevState) => ({
                                    ...prevState,
                                    queueId: opt
                                }));
                            }}
                            selected={register.queueId}
                            closeOnSelect={true}
                            style={{
                                height: '37px',
                            }}
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={2} mb={2} hidden={true}>
                    <Grid item xs={12}>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={register?.limitByDate == true ? true : false}
                                    onChange={() => {
                                        setRegister((prevState) => ({
                                            ...prevState,
                                            limitByDate: !prevState.limitByDate
                                        }));
                                    }}
                                    name="limitByDate"
                                    color="primary"
                                />
                            }
                            label={i18n.t("connections.whatsapp.importMessages.limitByDate")}
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={2} mb={2} hidden={register?.limitByDate != true ? true : false}>
                    <Grid item xs={6}>
                        <Typography
                            component="label"
                            sx={{ fontSize: '1.1rem', marginBottom: '10px' }}
                            onClick={() => startRef.current?.showPicker()}
                        >
                            {i18n.t("connections.whatsapp.importMessages.startDate")} <Typography color="error" component="span">*</Typography>
                        </Typography>
                        <TextField
                            inputRef={startRef}
                            name="importStartDate"
                            variant="outlined"
                            className="form-control"
                            fullWidth
                            value={register?.startDate}
                            inputProps={{ max: today }}
                            type="date"
                            onClick={(e) => e.target.showPicker()}
                            onChange={(e) => {
                                let startDate = String(e.target.value);
                                setRegister((prevState) => ({
                                    ...prevState,
                                    startDate,
                                    endDate: getEndDate(startDate)
                                }));
                            }}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <Typography
                            component="label"
                            sx={{ fontSize: '1.1rem', marginBottom: '10px' }}
                            onClick={() => endRef.current?.showPicker()}
                        >
                            {i18n.t("connections.whatsapp.importMessages.endDate")} <Typography color="error" component="span">*</Typography>
                        </Typography>
                        <TextField
                            inputRef={endRef}
                            name="importEndDate"
                            variant="outlined"
                            className="form-control"
                            fullWidth
                            value={register?.endDate}
                            inputProps={{ max: register?.startDate || today }}
                            type="date"
                            onClick={(e) => e.target.showPicker()}
                            onChange={(e) => {
                                let endDate = String(e.target.value);
                                setRegister((prevState) => ({
                                    ...prevState,
                                    endDate,
                                }));
                            }}
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={2} mb={2}>
                    <Grid item xs={12}>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={register?.allowGroups == true ? true : false}
                                    onChange={() => {
                                        setRegister((prevState) => ({
                                            ...prevState,
                                            allowGroups: !prevState.allowGroups
                                        }));
                                    }}
                                    name="allowGroups"
                                    color="primary"
                                />
                            }
                            label={i18n.t("connections.whatsapp.importMessages.allowGroups")}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={() => {
                        handleClose();
                    }}
                    variant="outlined"
                    color="error"
                    disabled={loading}
                >
                    {i18n.t("connections.whatsapp.importMessages.buttons.close")}
                </Button>
                <Button
                    onClick={() => {
                        handleSave();
                    }}
                    variant="contained"
                    color="primary"
                    disabled={loading}
                >
                    {i18n.t("connections.whatsapp.importMessages.buttons.save")}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default ImportWhatsappMessageStoreModal;